import { Button, For, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import { isHalfActiveFamily } from '../monitoring.utils';
import { useMonitoringContext } from '../MonitoringContext';

export default function FamilyFilter() {
  const { state, toggleFamily } = useMonitoringContext();
  const { families } = state;

  if (families.size <= 1) {
    return null;
  }

  return (
    <VStack gap={2} paddingX={2} paddingY={3} alignItems="start" width="100%" backgroundColor="neutral.850">
      <Text fontWeight="medium" color="neutral.300">
        <FormattedMessage id="components.monitoring.filter.families" />
      </Text>
      <SimpleGrid columns={2} width="100%" gap={1}>
        <For each={Array.from(families.entries())}>
          {([family, value]) => (
            <Button
              variant="toggle"
              size="toggleM"
              flex={1}
              key={family}
              flexBasis="40%"
              data-active={value}
              textTransform="uppercase"
              data-half-active={!value && isHalfActiveFamily(family, state.ladTypes, state.perimTypes)}
              onClick={() => toggleFamily(family)}
            >
              <FormattedMessage id={`sensors.families.${family}`} />
            </Button>
          )}
        </For>
      </SimpleGrid>
    </VStack>
  );
}
